import styled from 'styled-components'

export const Card = styled.div.attrs((props) => ({
  className: 'card ' + props.className,
}))`
  /* background: #ffffff; */
  box-shadow: 0px 0.6px 1.8px rgba(0, 0, 0, 0.11), 0px 3.2px 7.2px rgba(0, 0, 0, 0.133);
  width: 100%;
  height: 100%;
  padding: 40px 16px;
`
